import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

class ArtworkThanks extends React.Component{


	render(){
		return (<div className="absolute artwork-thanks-holder">
				<div className="artwork-thanks-inner">
					<p>Thanks for being part of our raffle! We're getting back to you at April 3rd.</p>
					<button onClick={()=>this.props.goToInnerChapterByNumber(1)}>Continue the blossomentary</button>
				</div>
			</div>);
	}
}

export default ArtworkThanks;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork-thanks.js